import { Box, Button, Collapse, Heading, Image, Tag, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { useLanguage, useLocalizedData } from "contexts/LocalizationContext";
import { getFunnelUrl } from "utils/getFunnelUrl";
import { images } from "../config";
import type { ResultProps } from "../types";
import { calculateCompensation } from "./utils";

export const Result = ({
  departureAirport,
  arrivalAirport,
  numberOfPassengers,
  message,
  successMessage,
  ctaButtonText,
  variant,
}: ResultProps) => {
  const { getLocalizedCurrency } = useLocalizedData();
  const language = useLanguage();

  const compensation = useMemo(
    () => calculateCompensation(departureAirport, arrivalAirport, numberOfPassengers),
    [departureAirport, arrivalAirport, numberOfPassengers]
  );

  const shouldShowResult = useMemo(() => Boolean(compensation), [compensation]);

  const funnelUrl = useMemo(
    () => getFunnelUrl(departureAirport, arrivalAirport, language),
    [departureAirport, arrivalAirport, language]
  );

  return (
    <Collapse in={shouldShowResult} style={{ overflow: "visible" }}>
      <Box position="relative" bgColor="primary.100" px={4} py={6} rounded="2xl">
        <Image {...images[variant]} />

        <Tag variant="outline" colorScheme="primary" mb={3}>
          {successMessage}
        </Tag>
        <Heading as="span" variant="h1" display="block" mb={2}>
          {getLocalizedCurrency(Number(compensation), "EUR")}
        </Heading>
        <Text as="span" fontSize="md" color="greyscale.600">
          {message}
        </Text>
        <Button as="a" href={funnelUrl} textAlign="center" display="block" width="full" variant="primary" mt={6}>
          {ctaButtonText}
        </Button>
      </Box>
    </Collapse>
  );
};
